module.exports = __webpack_public_path__ + "img/Frame 1000003127.01d5fe20.svg";